<template>
    <div class="navbar" >
        <div class="user d-flex a-center">
            <el-dropdown @command="handleClick">
                <span class="el-dropdown-link d-flex a-center">
                    <el-avatar style="margin-right:10px;" size="medium"
                        src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
                    {{ $store.state.user.username }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="resetPassword">修改密码</el-dropdown-item>
                    <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'Header',
    emits: ['reset-password', 'logout'],
    data() {
        return {
            modal1: false,
        }
    },
    methods: {
        ...mapMutations(['logout']),
        handleClick(command) {
            if (command === 'resetPassword') {
                this.$emit('reset-password');
            } else if (command === 'logout') {
                // this.$emit('logout');
                this.handleLogout();
            }
        },
        handleLogout() {
            //退登
            this.logout()
            this.$router.push('/login')
        },
        showResetPassword() {
            this.modal1 = true
        },
    }
}
</script>

<style scoped lang="less">
// 基础样式变量
@header-height: 72px;


// 导航栏样式
.navbar {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
}

// Element UI 组件样式覆盖
/deep/ .el-dropdown {
    color: #ffffff;
}
</style>